import { useRegisterEvents, useSigma } from '@react-sigma/core';
import { useEffect } from 'react';

type GraphEventsControllerProps = {
  setHoveredNode: (nodeId: string | null) => void;
  onNodeClick: (nodeId: string) => void;
  onEdgeClick: (edgeId: string) => void;
  onStageClick: () => void;
};

export const GraphEventsController = ({
  setHoveredNode,
  onNodeClick,
  onEdgeClick,
  onStageClick,
}: GraphEventsControllerProps) => {
  const sigma = useSigma();
  const graph = sigma.getGraph();
  const registerEvents = useRegisterEvents();

  useEffect(() => {
    const setPointer = (enabled: boolean) => {
      const mouseLayer = document.querySelector('.sigma-mouse');
      if (!mouseLayer) return;
      if (enabled) mouseLayer.classList.add('mouse-pointer');
      else mouseLayer.classList.remove('mouse-pointer');
    };

    registerEvents({
      clickNode: ({ node }) => {
        if (!graph.getNodeAttribute(node, 'hidden')) onNodeClick(node);
      },
      clickEdge: ({ edge }) => {
        if (!graph.getEdgeAttribute(edge, 'hidden')) onEdgeClick(edge);
      },
      clickStage: () => onStageClick(),
      enterNode: ({ node }) => {
        setHoveredNode(node);
        setPointer(true);
      },
      leaveNode: () => {
        setHoveredNode(null);
        setPointer(false);
      },

      enterEdge: ({ edge }) => {
        if (!graph.getEdgeAttribute(edge, 'hidden')) setPointer(true);
      },
      leaveEdge: () => {
        setPointer(false);
      },
    });
  }, [registerEvents, graph, onNodeClick, onEdgeClick, onStageClick, setHoveredNode]);

  return null;
};
